import styled from 'styled-components'
import EBoxSm from './EBoxSm'

const ButtonContainer = styled(EBoxSm)`
  font-size: 13px;
  font-weight: 600;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 20px;
  color: ${({ theme }) => theme.colors.textSubtle};
  transition: background 200ms ease, color 200ms ease, transform 120ms ease;

  &:hover {
    background: ${({ theme }) => theme.colors.tertiary};
    color: ${({ theme }) => theme.colors.text};
  }

  &:active {
    transform: scale(0.97);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

const ActiveButtonContainer = styled(ButtonContainer)`
  color: ${({ theme }) => theme.colors.white};
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) =>
  theme.colors.primaryBright} 100%);
  box-shadow: 0 6px 16px -8px rgba(139, 92, 246, 0.9), inset 0 1px 0 rgba(255, 255, 255, 0.18);

  &:hover {
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) =>
  theme.colors.primaryBright} 100%);
    color: ${({ theme }) => theme.colors.white};
    filter: brightness(1.08);
  }
`

const EButtonSm = ({ children, onClick = undefined, isActive = false, ...rest }) => {
  const Container = isActive ? ActiveButtonContainer : ButtonContainer
  return (
    <Container {...rest} isActive={isActive} onClick={onClick}>
      {children}
    </Container>
  )
}

export default EButtonSm
